import { useState } from "react";
import type { CommentType } from "../../../api/useComments";

export default function useSetupCommentType(projectId: string, enabled: boolean) {
  const [selection, setSelection] = useState({ projectId, enabled, setup: enabled });

  const hasContextChanged = selection.projectId !== projectId || selection.enabled !== enabled;
  // Reset synchronously so a mode/project change cannot publish using the previous choice.
  if (hasContextChanged) {
    setSelection({ projectId, enabled, setup: enabled });
  }

  const type: CommentType = selection.setup ? "SETUP" : "RUN";

  return {
    type,
    toggle: () => {
      if (!enabled) return;
      setSelection({ projectId, enabled, setup: !selection.setup });
    },
    reset: () => setSelection({ projectId, enabled, setup: enabled }),
  };
}
